import { WritableSignal } from "@angular/core";

export interface TrySuccess<T> {
    type: 'success';
    data: T;
}

export interface TryError {
    type: 'error';
    error: unknown;
}

export type TryResult<T> = TrySuccess<T> | TryError;

export function tryExecute<TReturn>(
    func: () => TReturn,
    signal?: WritableSignal<boolean>,
): TryResult<TReturn> {
    try {
        signal?.set(true);
        const data = func();
        return {type: 'success', data};
    } catch (e) {
        return {type: 'error', error: e};
    } finally {
        signal?.set(false);
    }
}

export async function tryExecuteAsync<TReturn>(
    promise: Promise<TReturn>,
    signal?: WritableSignal<boolean>,
): Promise<TryResult<TReturn>> {
    try {
        signal?.set(true);
        const data = await promise;
        return {type: 'success', data};
    } catch (e) {
        return {type: 'error', error: e};
    } finally {
        signal?.set(false);
    }
}
